export default __webpack_public_path__ + "static/media/logo-JetOS-symbol-only.7ef651c0.svg";